import engineUserAgent from './engine-user-agent.js';

var userAgent = engineUserAgent;
var stringPadWebkitBug = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent);

export { stringPadWebkitBug as default };
